<template lang="pug">
  div
    v-dialog(v-model='dialogWholesaler' persistent width='350')
      v-card
        v-card-title.text-h5.grey.lighten-2
          | MINORISTA / MAYORISTA
        v-card-text
          v-row
            v-col(cols="6")
              v-checkbox(id="checkMin" :label="activeValView" style="margin: 0px;" v-model="checkMin" @click="clickCheckMin")
            v-col(cols="6")
              v-checkbox(id="checkMay" :label="activeValueWholesalerView" style="margin: 0px;" v-model="checkMay" @click="clickCheckMay")
        v-divider
        v-card-actions
          v-spacer
          v-btn(color='red' text='' @click='cancelPriceDialog')
            | CANCELAR
          v-spacer
          v-btn(color='primary' @click='setValSelected')
            | LISTO
    <!--v-dialog(fullscreen="" v-model='dialodInvModCombo')-->
      <!--v-card-->
        <!--menu-combo-modal(@closeModal="closeInventoryModalCombo" :productToEdit='productToEditCombo' :forEditProduct='forEditProductCombo')-->
    v-dialog(fullscreen="" v-model='dialodInvMod')
      v-card
        inventoryDataModal(@closeModal="closeInventoryModal" :productToEdit='productToEdit' :forEditProduct='forEditProduct')
    v-dialog(v-model='dialogError' width='500' persistent)
      v-card
        v-card-title.text-h5.grey.lighten-2
          p(style="color: red; font-size=20px;") FACTURA GENERADA CON ERROR
        v-card-text
          | {{msgFacError}}
        v-divider
        v-card-actions
          v-spacer
          v-btn(color='primary' @click="$emit('closeModalSale')")
            | ACEPTAR
    v-dialog(v-model='dialogSaveFac' width='500')
      v-card
        v-card-title.text-h5.grey.lighten-2
          | DATOS DE PAGO
        v-row(style="padding: 20px;")
          v-col(cols='12' md="6")
            v-text-field.purple-input(label="Valor a Pagar" v-model="factura.total" readonly)
          v-col(cols='12' md="6")
            v-text-field.purple-input(@keyup="calculateTurned" :rules='[rules.required]' label="Valor Pagado" v-model="valPayment" type="text" @keypress="isNumber($event)")
          v-col(cols='12' md="6" offset-md="6")
            label(style="font-size: 20px;") VUELTO: ${{valTurned}}
          v-col(cols="12")
            v-alert(v-model="alertProductTurned" dismissible dense='' border='left' type='error')
              | {{msgAlertTurned}}
        v-divider
        v-card-actions
          v-spacer
          v-btn(color='primary' @click='makePayment')
            | FACTURAR
    v-dialog(fullscreen="" v-model='dialogCLient')
      v-card
        registro-cliente-modal(@closeModal="closeModalClient" :clientToEdit="clientToEdit")
    //- <!--v-dialog(fullscreen="" v-model='dialodProveedor')-->
    //- <!--v-card-->
    //- <!--registro-proveedor-modal(@closeModal="closeModalProvider" :providerToEdit='providerToEdit')-->
    v-snackbar(v-model='snackbar.show' :timeout='10000' :color='snackbar.color' top='' right='' :multi-line='multiLine')
      | {{ snackbar.text }}
      template(v-slot:action='{ attrs }')
        v-btn(dark='' text='' icon='' @click='snackbar.show = false' v-bind='attrs')
          v-icon mdi-close
    //- v-snackbar(:timeout='10000' top='' right='' :color='snackbar.color' v-model='snackbar.show')
    //-   | {{ snackbar.text }}
    //-   v-btn(dark='' text='' @click.native='snackbar.show = false' icon='' style='background: transparent;')
    //-     v-icon mdi-close
    v-dialog(v-model='confirmationDialogProduct' persistent max-width='290')
      v-card
        v-card-title.text-h5
          | Confirmar
        v-card-text ¿Está seguro de eliminar este registro?
        v-card-actions
          v-spacer(style="text-align: right;")
            v-btn(color='red darken-1' text='' @click='confirmationDialogProduct = false')
              | Cancelar
            v-btn(color='primary' @click='acceptConfirmationDelete')
              | Aceptar
    v-dialog(v-model='dialogAddCombo' persistent width='500')
      v-card
        v-card-title.text-h5.grey.lighten-2
          | Combos
        v-card-text
          v-form(ref='formAddProductCombo' v-model='validAddProduct' lazy-validation='' style="padding-top: 10px;")
            v-row
              v-col(cols='12' md="6" style='padding-top: 0; padding-bottom: 0;')
                v-text-field.purple-input(type="text" @keypress="isNumber($event)" @keyup="calculateSubtotal" :rules='[rules.required]' label="Cantidad" v-model="product.cantidad")
              v-col(cols='12' md="6" style='padding-top: 0; padding-bottom: 0;')
                v-text-field.purple-input(:rules='[rules.required]' label="Subtotal" v-model="product.total" type="text" @keypress="isNumber($event)" disabled)
        v-divider
        v-card-actions
          v-spacer(style="text-align: right;")
            v-btn(color='red darken-1' text='' @click='dialogAddCombo = false')
              | Cancelar
            v-btn(color='primary' @click="addProductCombo" :disabled="disableAdd")
              | Agregar
    v-dialog(v-model='dialogAddProduct' persistent max-width='500')
      v-card
        v-card-title
          h3 Productos
        v-card-text
          v-row(style="margin-bottom: 10px;")
            v-col(cols="6" style="padding: 0px;")
              h3(style="padding-left: 22px;") IVA: {{valIvaTxt}}
            //v-col(cols="4" style="padding: 0px;")
              v-checkbox(label="IVA CERO" style="margin: 0px;" v-model="product.porcentajecero")
            v-col(v-if="product.producto && product.producto.type.texto === 'BIEN'" cols="6" style="padding: 0px; text-align: right;")
              h3(style="padding-right: 25px; color: red;" v-if="product.producto.quantity - product.cantidad < 0") STOCK: {{product.producto.quantity - product.cantidad}}
              h3(style="padding-right: 25px;" v-if="product.producto.quantity - product.cantidad >= 0") STOCK: {{product.producto.quantity - product.cantidad}}
          v-form(ref='formAddProduct' v-model='validAddProduct' lazy-validation='' style="padding-top: 10px;")
            v-row
              v-col(cols='10' md='11' style='padding-top: 0; padding-bottom: 0;' v-if="!$store.state.profile.profileLoaded.productPrice")
                v-autocomplete(:rules='[rules.required]' @change="getProductValue(product, product.producto.activeValue, product.producto.tarifaiva.texto)" v-model='product.producto' :items='productsLst' return-object='return-object' item-text='completeData' label='Productos')
              v-col(cols='10' md='11' style='padding-top: 0; padding-bottom: 0;' v-if="$store.state.profile.profileLoaded.productPrice")
                v-autocomplete(:rules='[rules.required]' @change="getProductValueWholesaler(product, product.producto.activeValue, product.producto.activeValueWholesaler, product.producto.tarifaiva.texto)" v-model='product.producto' :items='productsLst' return-object='return-object' item-text='completeData' label='Productos')
                <!--v-autocomplete(:rules='[rules.required]' @change="getProductValue(product, product.producto.activeValue, product.producto.tarifaiva.texto)" v-model='product.producto' :items='productsLst' return-object='return-object' item-text='completeData' label='Productos')-->
              <!--v-col(cols='10' md='11' style='padding-top: 0; padding-bottom: 0;' v-if="$store.state.profile.profileLoaded.productPrice")-->
                <!--v-autocomplete(:rules='[rules.required]' @change="getProductValueWholesaler(product, product.producto.activeValue, product.producto.activeValueWholesaler, product.producto.tarifaiva.texto)" v-model='product.producto' :items='productsLst' return-object='return-object' item-text='completeData' label='Productos')-->
              v-col.py-0.pl-0.ml-0(cols="2" md="1")
                v-tooltip(bottom="")
                  template(v-slot:activator="{ on }")
                    v-btn(:disabled="factura.id" v-on="on" icon text color="purple darken-3" @click="addNewProduct" style='background:#B18BE2;')
                      v-icon(style="font-size: 25px;") mdi-plus
                  span.tooltips Crear Producto
              v-col(cols='12' md="6" style='padding-top: 0; padding-bottom: 0;')
                v-text-field.purple-input(type="text" @keypress="isNumber($event)" @keyup="calculateSubtotalKeyUp" :rules='[rules.required]' label="Cantidad" v-model="product.cantidad")
              v-col(cols='12' md="6")
                v-text-field.purple-input(type="text" @keypress="isNumber($event)" @keyup="calculateSubtotalKeyUp" :rules='[rules.required]' label="Valor Unitario SIN IVA" v-model="product.valorUnitario" style='padding-top: 0; padding-bottom: 0;')
              v-col(cols="12" md="6" style='padding-top: 0; padding-bottom: 0;')
                v-row(style='padding-bottom: 0;')
                  v-col(cols="3" style="padding-top: 0px;")
                    v-switch(@change="calculateSubtotalKeyUp" color='primary' value='' v-model="banDescuento")
                  v-col(cols="9" style="padding-top: 0px;")
                    v-text-field.purple-input(type="text" @keypress="isNumber($event)" @keyup="calculateSubtotalKeyUp" :label="banDescuento ? 'DCTO. VALOR ($)' : 'DCTO. PORCENTAJE (%)'" v-model="dctoProduct")
              v-col(cols='12' md="6" style='padding-top: 0; padding-bottom: 0;')
                v-text-field.purple-input(:rules='[rules.required]' label="Subtotal" v-model="product.total" type="text" @keypress="isNumber($event)" disabled)
              v-col(cols='12' style='padding-top: 0; padding-bottom: 0;')
                v-text-field.purple-input(label="Observación" v-model="product.descripcion" type="text")
              v-col(cols="12" style='padding-top: 0; padding-bottom: 0;')
                v-alert(v-model="alertProductData" dismissible dense='' border='left' type='error')
                  | {{msgAlertProducts}}
            v-card-actions
              v-spacer(style="text-align: right;")
                v-btn(color='red darken-1' text='' @click='dialogAddProduct = false')
                  | Cancelar
                v-btn(color='primary' @click="addProduct" :disabled="disableAdd")
                  | Agregar
    v-card
      v-toolbar(text='' color='primary' dark='')
        v-toolbar-title(v-if="!factura.id")
          h4 Fac. {{profileLoaded.estab}}-{{profileLoaded.ptoEmi}}-{{profileLoaded.secuenciales.facventa.padStart(9, '0')}}
          v-btn(icon="" dark="" style="position: absolute; top: 0px; right: 10px;" @click="$emit('closeModalSale')")
            v-icon.primary.rounded mdi-close
        v-toolbar-title(v-if="factura.id")
          h4 Fac. {{factura.numsecuencial}}
          v-btn(icon="" dark="" style="position: absolute; top: 0px; right: 10px;" @click="$emit('closeModalSale')")
            v-icon.primary.rounded mdi-close
      v-card-text
        v-row(style="margin-top: 20px;")
          v-form(ref='formAddFactura' v-model='validAddFactura' lazy-validation='' style="width: 100%; margin: 10px;")
            v-row
              div(v-if="comboLst.length > 0")
                v-row(style='width: 100%; margin: 0;')
                  v-col(cols="12" md="5" style="padding-bottom: 0px;")
                    v-row(style='padding-top:0;')
                      v-col(cols="10" md="11" style="padding-top: 0px;")
                        v-text-field(v-model="searchCombo" @keyup="filterComboTxt" append-icon="mdi-search" label= "Buscar Combo | Código, Nombre, Descripción" single-line="" hide-details="" clearable style="margin-top: 0px; padding-top: 0px;")
                      v-col.py-0.pl-0.ml-0(cols="2" md="1" style="text-align: center;")
                        v-tooltip(bottom="")
                          template(v-slot:activator="{ on }")
                            v-btn(:disabled="factura.id" v-on="on" icon text color="purple darken-3" @click="addNewProductCombo" style='background:#B18BE2;')
                              v-icon(style="font-size: 25px;") mdi-plus
                          span.tooltips Crear Combo
                      v-col.py-0(cols='10' md='11')
                        v-autocomplete(dense="" :disabled="factura.id" :rules='[rules.required]' v-model='factura.client' :items='clientLst' return-object='return-object' item-text='completeData' label='Cliente')
                      //- Nuevo proveedor
                      v-col.py-0.pl-0.ml-0(cols="2" md="1" style="text-align: center;")
                        v-tooltip(bottom="")
                          template(v-slot:activator="{ on }")
                            v-btn(:disabled="factura.id" v-on="on" icon text color="purple darken-3" @click="addNewClient" style='background:#B18BE2;')
                              v-icon(style="font-size: 25px;") mdi-plus
                          span.tooltips Crear Cliente
                      //- Formas de pago
                      v-col.py-0(cols="12" md="12")
                        v-autocomplete(:disabled="factura.id" :rules='[rules.required]' v-model="factura.formapago" required :items='electronicbillingtables ? electronicbillingtables.formaspago : []' return-object item-text="formapago" dense='')
                          template(#label="")
                            span.red--text
                              strong *
                            | {{ ' ' + 'Forma de pago' }}
                      v-col.py-0(cols="12" md="9")
                        v-text-field(:disabled="factura.id || (factura.formapago != null ? (factura.formapago.codigo.toString() !== '16' && factura.formapago.codigo.toString() !== '18' && factura.formapago.codigo.toString() !== '19') : true)" v-model="factura.numeroVoucher" required :items='plazoDias' return-object item-text="name" dense='')
                          template(#label="")
                            | {{ ' ' + 'Número Voucher' }}
                      v-col(cols="12" md="3" style="padding: 0px;")
                        v-checkbox(:disabled="factura.id" label="Nota de Venta" style="margin: 0px; color: red;" v-model="notaVenta")
                      //- Fecha de emision
                      v-col.py-0(cols="12" md="4")
                        v-menu(:disabled="factura.id" ref='startMenu1' v-model='startMenu1' :close-on-content-click='false' :nudge-right='40' :return-value.sync='factura.fechaEmision' transition='scale-transition' min-width='290px' offset-y='')
                          template(v-slot:activator='{ on }')
                            v-text-field(readonly dense="" :rules='[rules.required]' v-model='computedDateFormattedMomentjs' prepend-icon='mdi-calendar' v-on='on')
                              template(#label="")
                                span.red--text
                                  strong *
                                | {{ ' ' + 'Fecha de Emisión' }}
                          v-date-picker.my-0(:max="currentDate" :rules='[rules.required]' v-model='factura.fechaEmision' no-title='' scrollable='' locale='es-ec' @change="$refs.startMenu1.save(factura.fechaEmision)" color="green lighten-1")
                      v-col.py-0(cols="6" md="4")
                        v-menu(:disabled="factura.id || !factura.pendientepago" ref='startMenu2' v-model='startMenu2' :close-on-content-click='false' :nudge-right='40' :return-value.sync='factura.fechapago' transition='scale-transition' min-width='290px' offset-y='')
                          template(v-slot:activator='{ on }')
                            v-text-field(readonly :disabled="factura.id || !factura.pendientepago" dense="" v-model='computedDateFormattedMomentPagojs' prepend-icon='mdi-calendar' v-on='on')
                              template(#label="")
                                | {{ ' ' + 'Fecha de Pago' }}
                          v-date-picker.my-0(:min="currentDate" v-model='factura.fechapago' no-title='' scrollable='' locale='es-ec' @change="$refs.startMenu2.save(factura.fechapago)")
                      v-col(cols="6" md="4" style="padding: 0px;")
                        v-checkbox(:disabled="factura.id" label="Pendiente de Pago" style="margin: 0px; color: blue;" v-model="factura.pendientepago")
                      //v-col(cols="5" md="1" style="padding: 0px;")
                        v-checkbox(@change="changeSendSri" :disabled="factura.id || (companyDataLoad ? !companyDataLoad.sendSri : true)" label="Env. SRI" style="margin: 0px;" v-model="sendSri")
                      //- Proveedor
                      //v-col.py-0(cols="10" md="5")
                        v-autocomplete(:disabled="factura.id" :rules='[rules.required]' v-model='factura.proveedor' :items='arrayProveedores' return-object='return-object' item-text='completeData' label='Proveedor')
                      //- Nuevo proveedor
                      //v-col.py-0.pl-0.ml-0(cols="2" md="1")
                        v-tooltip(bottom="")
                          template(v-slot:activator="{ on }")
                            v-btn(:disabled="factura.id" v-on="on" icon text color="purple darken-3" @click="dialodProveedor = true")
                              v-icon(style="font-size: 25px;") mdi-plus
                          span Crear Proveedor
                      v-col.py-0(cols="12" md="12")
                        v-text-field(:disabled="factura.id" dense="" v-model="factura.descripcion")
                          template(#label="")
                            |{{ ' ' + 'Descripción' }}
                  v-col(cols="12" md="7" style="padding-bottom: 0px;")
                    v-card(class="view-combo-card" style="height: 270px; max-height: 270px !important;  min-height: 270px !important; overflow-y: scroll !important;")
                      v-card-text(style="padding: 0px;")
                        v-row(style="margin: 0px; padding: 0px;")
                          v-col(cols="3" md="2" v-for='(combo, index) in comboLstFilter' :key='index' style="margin: 0px; padding: 0px; padding-left: 5px; padding-right: 5px;").text-center
                            v-tooltip(bottom='')
                              template(v-slot:activator='{ on, attrs }')
                                v-btn(@click="addnewCombo(combo)" icon='' color='blue' v-on='on' style="background: transparent; margin: 10px; background-color: #1d1d1d; border-radius: 0px; width: 100%; height: 60px; margin-bottom: 0px;" :loading="loadingPrintFac").mt-4
                                  v-icon(style="font-size: 40px;") mdi-food
                                  p(style="position: absolute; top: -17px; left: 5px; color: white; font-size: 20px; font-weight: bold;") {{combo.codArticle}}
                                p(style="font-size: 7px; text-align: center; width: 100%; font-weight: bold; margin-left: 10px; background-color: gray; color: white;") {{combo.name}}
                              span.tooltips {{combo.description}}
              div(v-if="comboLst.length === 0")
                //- Fecha de emision
                v-row(style="width:100%;")
                  v-col.py-0(cols="12" md="2")
                    v-menu(:disabled="factura.id" ref='startMenu1' v-model='startMenu1' :close-on-content-click='false' :nudge-right='40' :return-value.sync='factura.fechaEmision' transition='scale-transition' min-width='290px' offset-y='')
                      template(v-slot:activator='{ on }')
                        v-text-field(readonly dense="" :rules='[rules.required]' v-model='computedDateFormattedMomentjs' prepend-icon='mdi-calendar' v-on='on')
                          template(#label="")
                            span.red--text
                              strong *
                            | {{ ' ' + 'Fecha de Emisión' }}
                      v-date-picker.my-0(:max="currentDate" :rules='[rules.required]' v-model='factura.fechaEmision' no-title='' scrollable='' locale='es-ec' @change="$refs.startMenu1.save(factura.fechaEmision)" color="green lighten-1")
                  //- Formas de pago
                  v-col.py-0(cols="12" md="4")
                    v-autocomplete(:disabled="factura.id" :rules='[rules.required]' v-model="factura.formapago" required :items='electronicbillingtables ? electronicbillingtables.formaspago : []' return-object item-text="formapago" dense='')
                      template(#label="")
                        span.red--text
                          strong *
                        | {{ ' ' + 'Forma de pago' }}
                  v-col.py-0(cols="12" md="2")
                    v-text-field(:disabled="factura.id || (factura.formapago != null ? (factura.formapago.codigo.toString() !== '16' && factura.formapago.codigo.toString() !== '18' && factura.formapago.codigo.toString() !== '19') : true)" v-model="factura.numeroVoucher" required :items='plazoDias' return-object item-text="name" dense='')
                      template(#label="")
                        | {{ ' ' + 'Número Voucher' }}
                  v-col(cols="6" md="2" style="padding: 0px;")
                    v-checkbox(:disabled="factura.id" label="Pendiente de Pago" style="margin: 0px; color: blue;" v-model="factura.pendientepago")
                  v-col.py-0(cols="6" md="2")
                    v-menu(:disabled="factura.id || !factura.pendientepago" ref='startMenu2' v-model='startMenu2' :close-on-content-click='false' :nudge-right='40' :return-value.sync='factura.fechapago' transition='scale-transition' min-width='290px' offset-y='')
                      template(v-slot:activator='{ on }')
                        v-text-field(readonly :disabled="factura.id || !factura.pendientepago" dense="" v-model='computedDateFormattedMomentPagojs' prepend-icon='mdi-calendar' v-on='on')
                          template(#label="")
                            | {{ ' ' + 'Fecha de Pago' }}
                      v-date-picker.my-0(:min="currentDate" v-model='factura.fechapago' no-title='' scrollable='' locale='es-ec' @change="$refs.startMenu2.save(factura.fechapago)")
                  //v-col(cols="5" md="1" style="padding: 0px;")
                    v-checkbox(@change="changeSendSri" :disabled="factura.id || (companyDataLoad ? !companyDataLoad.sendSri : true)" label="Env. SRI" style="margin: 0px;" v-model="sendSri")
                  //- Descripcion
                  v-col.py-0(cols='10' md='6')
                    v-autocomplete(dense="" :disabled="factura.id" :rules='[rules.required]' v-model='factura.client' :items='clientLst' return-object='return-object' item-text='completeData' label='Cliente')
                  //- Nuevo proveedor
                  v-col.py-0.pl-0.ml-0(cols="2" md="1" style="text-align: center;")
                    v-tooltip(bottom="")
                      template(v-slot:activator="{ on }")
                        v-btn(:disabled="factura.id" v-on="on" icon text color="purple darken-3" @click="addNewClient" style='background:#B18BE2;')
                          v-icon(style="font-size: 25px;") mdi-plus
                      span.tooltips Crear Cliente
                  //- Proveedor
                  //v-col.py-0(cols="10" md="5")
                    v-autocomplete(:disabled="factura.id" :rules='[rules.required]' v-model='factura.proveedor' :items='arrayProveedores' return-object='return-object' item-text='completeData' label='Proveedor')
                  //- Nuevo proveedor
                  //v-col.py-0.pl-0.ml-0(cols="2" md="1")
                    v-tooltip(bottom="")
                      template(v-slot:activator="{ on }")
                        v-btn(:disabled="factura.id" v-on="on" icon text color="purple darken-3" @click="dialodProveedor = true")
                          v-icon(style="font-size: 25px;") mdi-plus
                      span Crear Proveedor
                  //v-col.py-0(cols="12" md="6" v-if="!profileLoaded.saleNoteBilling")
                    v-text-field(:disabled="factura.id" dense="" v-model="factura.descripcion")
                      template(#label="")
                        |{{ ' ' + 'Descripción' }}
                  //v-col.py-0(cols="12" md="4" v-if="profileLoaded.saleNoteBilling")
                    v-text-field(:disabled="factura.id" dense="" v-model="factura.descripcion")
                      template(#label="")
                        |{{ ' ' + 'Descripción' }}
                  v-col(v-if="!profileLoaded.saleNoteBilling" cols="12" md="5" style="padding-top: 0px")
                    v-btn(:disabled="factura.id" color='green' @click="addNewElement" style="width: 100%;")
                      | AGREGAR PRODUCTOS
                  v-col(v-if="profileLoaded.saleNoteBilling" cols="12" md="3" style="padding-top: 0px")
                    v-btn(:disabled="factura.id" color='green' @click="addNewElement" style="width: 100%;")
                      | AGREGAR PRODUCTOS
                  v-col(v-if="profileLoaded.saleNoteBilling" cols="12" md="2" style="padding: 0px;")
                    v-checkbox(:disabled="factura.id" label="Generar como Nota de Venta" style="margin: 0px; color: red;" v-model="notaVenta")
          v-row(style="margin-right: 20px;")
            v-col(cols="12" md="10" style="padding-bottom: 0px; padding-top: 0px;")
              v-row(style="margin-top: 10px;")
                v-col(cols="7" md="7" style="padding-top: 0px;")
                  //h2(v-if="comboLst.length === 0" style="padding-left: 50px; padding-top: 20px;") Lista de Productos
                  h3(v-if="comboLst.length > 0" style="padding-left: 50px; padding-top: 20px;") Lista de Productos y Combos
                v-col(v-if="comboLst.length > 0" cols="4" sm='2' class='addButton' style="padding-top: 0px;").text-right
                  v-btn(:disabled="factura.id" color='green' @click="addNewElement").mt-4
                    | AGREGAR PRODUCTOS
                v-col(cols="4" sm='2' class='addIcon').text-right
                  v-tooltip(bottom="")
                    template(v-slot:activator="{ on }")
                      v-btn(:disabled="factura.id"  v-on="on" icon='' style='background: transparent;' color='green').mt-4
                        v-icon(style="font-size: 40px;" @click="addNewElement") mdi-clipboard-plus
                    span.tooltips Agregar Productos
                v-col(cols="12" v-if="viewTable")
                  v-data-table(style="height: 300px; min-height: 430px; overflow-y: scroll;" :headers="headers" :items="factura.lstProductos" item-key="id" :search="search" dense fixed-header :loading="cargando" loading-text="Cargando" :footer-props="{\'items-per-page-text':'Productos por página'\, 'items-per-page-options':[10, 20, 30, 50, 100]}" :items-per-page="100")
                    template(v-slot:item.changeCant="{ item }")
                      v-tooltip(bottom="")
                        template(v-slot:activator="{ on }")
                          v-btn(v-if="!factura.id" text="" icon="" color='blue' v-on="on" @click="addProductComboCant(true, item, item.producto.combo)")
                            v-icon(small) mdi-plus
                        span.tooltips Aumentar
                      v-tooltip(bottom="")
                        template(v-slot:activator="{ on }")
                          v-btn(v-if="!factura.id" text="" icon="" color='red' v-on="on" @click="addProductComboCant(false, item, item.producto.combo)")
                            v-icon(small) mdi-minus
                        span.tooltips Restar
                    template(v-slot:item.cantidadView="{ item }")
                      p(style="font-size: 12px; font-weight: bold;") {{item.cantidad}}
                    template(v-slot:item.descuentoView="{ item }")
                      p(style="font-size: 12px;") ${{item.descuento}}
                    template(v-slot:item.valorUnitarioView="{ item }")
                      p(style="font-size: 12px;") ${{item.valorUnitario}}
                    template(v-slot:item.totalView="{ item }")
                      p(style="font-size: 12px; font-weight: bold;") ${{item.total}}
                    template(v-slot:item.codView="{ item }")
                      p(style="font-size: 10px;") {{item.producto.codArticle}}
                    template(v-slot:item.nameView="{ item }")
                      p(style="font-size: 10px;") {{item.producto.name}}
                    template(v-slot:item.action="{ item }")
                      v-tooltip(bottom="")
                        template(v-slot:activator="{ on }")
                          v-btn(v-if="!factura.id" :disabled="item.producto.combo" text="" icon="" color='blue' v-on="on" @click="editElement(item)")
                            v-icon(small) mdi-lead-pencil
                        span.tooltips Editar
                      v-tooltip(bottom="")
                        template(v-slot:activator="{ on }")
                          v-btn(v-if="!factura.id" text="" icon="" color='red' v-on="on" @click="openDeleteItem(item)")
                            v-icon(small) mdi-trash-can-outline
                        span.tooltips Eliminar
                    v-alert.pa-0.ma-0(slot='no-results', :value='true', color='error', icon='mdi-alert-octagon-outline')
                      | Sin resultados
                    v-alert.pa-0.ma-0(slot='no-data', :value='true', color='info', icon='mdi-information-outline')
                      | No se tiene datos
                    v-flex(xs12='', sm10='', offset-sm1='')
            v-col(cols="12" md="2" style="padding-bottom: 0px; padding-top: 0px;")
              v-row(style="padding-top: 30px;")
                v-col(cols="12" style="padding: 0px; text-align: right;")
                  label(style='font-size: 13px;') SUB TOTAL: ${{factura.subtotal}}
                v-col(cols="12" style="padding: 0px; text-align: right;")
                  label(style='font-size: 13px;') IVA {{factura.porcentajeiva}}%: ${{factura.iva12}}
                v-col(cols="12" style="padding: 0px; text-align: right;")
                  label(style='font-size: 13px;') SUB 0%: ${{factura.subcero}}
                v-col(cols="12" style="padding: 0px; text-align: right;")
                  label(style='font-size: 13px;') NO OBJETO DE IVA: ${{factura.noobjiva}}
                v-col(cols="12" style="padding: 0px; text-align: right;")
                  label(style='font-size: 13px;') EXCENTO DE IVA: ${{factura.excentoiva}}
                v-col(cols="12" style="padding: 0px; text-align: right;")
                  label(style='font-size: 13px;') TOTAL DESCUENTO: ${{factura.totdcto}}
                //v-col(cols="12" style="padding: 0px; text-align: right;")
                  label(style='font-size: 13px; width: 100px;') SALDO: ${{factura.saldo}}
                hr(style="border-color: white; width: 100%; margin: 5px -5px 5px 50px;")
                v-col(cols="12" style="padding: 0px; text-align: right;")
                  label(style='font-size: 16px; font-weight: bold; width: 100px;') TOTAL: ${{factura.total}}
              v-row
                v-col(cols="3" md="3").text-center
                  v-tooltip(bottom='')
                    template(v-slot:activator='{ on, attrs }')
                      v-btn(icon='' color='blue' v-on='on' style="background: transparent;" :loading="loadingPrintFac").mt-4
                        v-icon(style="font-size: 40px;" @click="printFacturaPrev") mdi-printer
                    span.tooltips Imprimir
                v-col(cols="3" md="3" v-if="").text-center
                  v-tooltip(bottom='')
                    template(v-slot:activator='{ on, attrs }')
                      v-btn(:disabled="(!factura.id) || (companyDataLoad ? !companyDataLoad.sendSri : true) || (factura.estadoProceso ? (factura.estadoProceso.toString() === '3' ? false : true) : true)" icon='' color='purple' v-on='on' style="background: transparent;" :loading="loadingSendMail").mt-4
                        v-icon(style="font-size: 40px;" @click="sendEmailFac") mdi-email
                    span.tooltips Enviar correo al cliente
                v-col(cols="3" md="3").text-center
                  v-tooltip(bottom='')
                    template(v-slot:activator='{ on, attrs }')
                      v-btn(:disabled="factura.id" v-on='on' icon='' color='orange' style="background: transparent;").mt-4
                        v-icon(style="font-size: 40px;" @click="cleanOperation") mdi-file-refresh
                    span.tooltips Limpiar Todo
                v-col(cols="3" md="3").text-center
                  v-tooltip(bottom='')
                    template(v-slot:activator='{ on, attrs }')
                      v-btn(:disabled="factura.id" v-on='on' icon='' color='primary' style="background: transparent;" @click="previewSaveFac" :loading="loadingSave").mt-4
                        v-icon(style="font-size: 40px;") mdi-content-save
                    span.tooltips Guardar
        v-row
          v-col(cols="12" md="12")
            v-alert(v-model="alertData" dismissible dense='' border='left' type='warning' v-if="companyDataLoad ? !companyDataLoad.sendSri : true")
              | Puede continuar con la generación de la factura para impresión sin inconvenientes, aunque actualmente no puede enviar sus comprobantes electrónicos del SRI, para resolver esto por favor complete sus datos de &nbsp
              a(@click='toCertifElect' alt='botón para continuar' style='color:blue;')
                strong(style="text-decoration: underline;") CERTIFICACIÓN ELECTRÓNICA.
            v-alert(v-model="alertData" dismissible dense='' border='left' type='info' v-if="companyDataLoad ? companyDataLoad.sendSri && sendSri : false")
              | Recuerde {{ }}
              strong ENVIAR {{ }}
              | sus facturas al SRI en la vista principal luego de generarlas. Puede enviarlas con el botón: {{" "}}
              v-icon(small style="font-size: 30px;") mdi-send {{ }}
              | {{ }} Puede {{ }}
              strong ENVIAR {{ }}
              | la factura al cliente mediante el botón: {{ }}
              v-icon(small style="font-size: 30px;") mdi-email
            v-alert(v-model="alertData" dismissible dense='' border='left' type='warning' v-if="companyDataLoad ? companyDataLoad.sendSri && !sendSri : false")
              | Su factura no se enviará al sistema del SRI. Para realizar el envío automático debe dar click en el campo Env. SRI.
</template>
<script>
  import moment from 'moment'
  import * as printerFunctions from '../../../../functions/printerFunctions.js'
  import * as functions from '../../../../functions.js'
  import {enviarEvento} from "../../../../functions.js";
  import * as vars from '../../../../vars.json'
  var accounting = require('accounting')
  export default {
    components: {
      // MenuComboModal: () => import('@/views/dashboard/component/application/MenuComboModal'),
      InventoryDataModal: () => import('@/views/dashboard/component/application/InventoryDataModal'),
      RegistroClienteModal: () => import('@/views/dashboard/component/application/RegistroClienteModal'),
      // RegistroProveedorModal: () => import('@/views/dashboard/component/application/RegistroProveedorModal'),
    },
    props: {
      facturaToEdit: {
        default: function () {
          return {
            numsecuencial: '',
            client: null,
            porcentajeiva: '',
            cedula: '',
            // cadAutorizacion: moment(new Date()).format('YYYY-MM-DD'),,
            telefono: '',
            email: '',
            direccion: '',
            lstProductos: [],
            subtotal: '0.00',
            subcero: '0.00',
            noobjiva: '0.00',
            excentoiva: '0.00',
            totdcto: '0.00',
            ice: '0.00',
            irbpnr: '0.00',
            iva12: '0.00',
            total: '0.00',
            fechaEmision: moment(new Date()).format('YYYY-MM-DD'),
            descripcion: '',
            formapago: null,
            proveedor: null,
            saldo: '0.00',
            numeroVoucher: null,
            pendientepago: false,
            fechapago: moment(new Date()).format('YYYY-MM-DD'),
          }
        },
        type: Object,
      },
    },
    data: () => ({
      checkMin: true,
      checkMay: true,
      activeValView: '',
      activeValueWholesalerView: '',
      txtIvaView: '',
      dialogWholesaler: false,
      note: {},
      notaVenta: false,
      forEditProductCombo: false,
      dialodInvModCombo: false,
      dialogAddCombo: false,
      searchCombo: '',
      productToEditCombo: {
        codArticle: '',
        barcode: '',
        name: '',
        description: '',
        type: {
          codigo: '02',
          texto: 'SERVICIO',
        },
        quantity: '1',
        activeValue: '',
        activeWValue: '',
        productKey: '',
        completeData: '',
        tarifaiva: {
          codigo: '2',
          texto: '12%',
          valor: '12',
        },
        irbpnr: '',
        tarifaice: '',
        totalValue: '',
        inecCode: null,
        combo: true,
      },
      productToEdit: {
        codArticle: '',
        barcode: '',
        name: '',
        description: '',
        type: {
          codigo: '01',
          texto: 'BIEN',
        },
        quantity: '',
        activeValue: '',
        activeWValue: '',
        productKey: '',
        completeData: '',
        tarifaiva: {
          codigo: '0',
          texto: '0%',
          valor: '0',
        },
        irbpnr: '',
        tarifaice: '',
        totalValue: '',
      },
      forEditProduct: false,
      dialodInvMod: false,
      loadingSendMail: false,
      initDate: moment(moment(new Date()).format('YYYY-MM-DD'), 'YYYY-MM-DD').subtract('days', 5),
      dialogError: false,
      msgFacError: '',
      alertProductTurned: false,
      msgAlertTurned: '',
      disableAdd: false,
      viewTable: true,
      alertProductData: false,
      msgAlertProducts: '',
      editProduct: false,
      loadingPrintFac: false,
      valTurned: '0.00',
      valPayment: '',
      dialogSaveFac: false,
      alertData: true,
      sendSri: true,
      currentDate: moment(new Date()).format('YYYY-MM-DD'),
      dctoProduct: '',
      banDescuento: true,
      valIvaTxt: '',
      dialogCLient: false,
      dialodProveedor: false,
      providerToEdit: {
        name: '',
        mail: '',
        personType: ['Natural'],
        ruc: '',
        telephone: '',
        phone: '',
        description: '',
        providerKey: '',
      },
      clientToEdit: {
        name: '',
        lastName: '',
        mail: '',
        address: '',
        ruc: '',
        phone: '',
        clientKey: '',
      },
      snackbar: {
        show: false,
        text: '',
        color: '',
      },
      formasPago: [
        {
          code: '001', name: 'EFECTIVO',
        },
        {
          code: '002', name: 'TARJETA',
        },
        {
          code: '003', name: 'TRANSFERENCIA',
        },
        {
          code: '004', name: 'CRÉDITO',
        },
      ],
      plazoDias: [
        {
          code: '001', name: '15 DÍAS',
        },
        {
          code: '002', name: '20 DÍAS',
        },
        {
          code: '003', name: '30 DÍAS',
        },
      ],
      validAddProduct: true,
      dialogAddProduct: false,
      confirmationDialogProduct: false,
      loadingSave: false,
      search: '',
      cargando: false,
      validAddFactura: true,
      startMenu1: false,
      startMenu2: false,
      rules: {
        required: value => !!value || 'Requerido',
        min: v => v.length >= 6 || 'Mínimo 6 caracteres',
      },
      arrCuentasActivos: [],
      typeLst: [
        { codigo: '1', nombre: 'FACTURA' },
        { codigo: '2', nombre: 'NOTA DE CRÉDITO' },
        { codigo: '3', nombre: 'NOTA DE VENTA' },
      ],
      headers: [
        { text: '', value: 'changeCant', align: 'left', filterable: true, width: '120px' },
        { text: 'Cant.', value: 'cantidadView', align: 'left', filterable: true, width: '10px' },
        { text: 'Cod.', value: 'codView', align: 'left', filterable: true },
        { text: 'Nombre', value: 'nameView', align: 'left', filterable: true },
        { text: 'Dcto.', value: 'descuentoView', align: 'left', filterable: true },
        { text: 'Val. Unit.', value: 'valorUnitarioView', align: 'left', filterable: true },
        // { text: 'Valor ICE', value: 'ice', align: 'left', filterable: true },
        // { text: 'Valor IRBPNR', value: 'irbpnr', align: 'left', filterable: true },
        { text: 'Tot.', value: 'totalView', align: 'left', filterable: true },
        { text: 'Acciones', align: 'center', value: 'action', sortable: false, width: '120px' }, // No se cambia
      ],
      factura: {},
      product: {
        producto: null,
        cantidad: '',
        descripcion: '',
        valorUnitario: '',
        total: '',
        porcentajecero: '',
        descuento: '',
        ice: '',
        irbpnr: '',
      },
      comboLstFilter: [],
      clientSet: null,
    }),
    computed: {
      comboLst () {
        return this.$store.state.product.lstCombos
      },
      computedDateFormattedMomentjs () {
        return this.factura.fechaEmision ? moment(this.factura.fechaEmision).format('DD/MM/YYYY') : ''
      },
      computedDateFormattedMomentPagojs () {
        return this.factura.fechapago ? moment(this.factura.fechapago).format('DD/MM/YYYY') : ''
      },
      arrayProveedores () {
        return this.$store.state.provider.lstProviders
      },
      clientLst () {
        return this.$store.state.client.lstClients
      },
      productsLst () {
        return this.$store.state.product.lstProductsActive
      },
      electronicbillingtables () {
        return this.$store.state.facturacion.electronicbillingtables
      },
      profileLoaded () {
        return this.$store.state.profile.profileLoaded
      },
      companyDataLoad () {
        return this.$store.state.facturacion.companydata
      },
      endClient () {
        return this.$store.state.client.endClient
      },
    },
    watch: {
      endClient () {
        this.clientSet = this.endClient
        if (this.clientSet !== null) {
          this.factura.client = this.clientSet
        }
      },
      ivaVal () {
        this.factura.porcentajeiva = vars.validIva
      },
      facturaToEdit () {
        this.notaVenta = false
        this.factura = this.facturaToEdit
        this.factura.porcentajeiva = vars.validIva
        this.alertData = true
      },
      comboLst () {
        this.comboLstFilter = this.comboLst
      },
    },
    created () {
      this.factura.porcentajeiva = vars.validIva
    },
    mounted () {
      enviarEvento('sale_billing', { categoria: 'interaccion', etiqueta: 'inicio' })
      this.notaVenta = false
      this.electronicbillingtables = this.$store.state.facturacion.electronicbillingtables
      this.factura = this.facturaToEdit
      this.clientSet = this.$store.state.client.endClient
      if (this.clientSet !== null) {
        this.factura.client = this.clientSet
      }
      this.alertData = true
      this.factura.porcentajeiva = vars.validIva
      this.comboLstFilter = this.$store.state.product.lstCombos
    },
    methods: {
      addProductComboCant (ban, item, banCombo) {
        this.product = item
        if (ban) {
          this.product.cantidad = parseFloat(this.product.cantidad) + 1
        } else {
          this.product.cantidad = parseFloat(this.product.cantidad) - 1
        }
        this.editProduct = true
        // this.dialogAddProduct = true
        this.banDescuento = true
        this.product = item
        this.dctoProduct = this.product.descuento
        this.alertProductData = false

        if (banCombo) {
          this.viewTable = true
          if (parseFloat(this.product.cantidad) <= 0) {
            this.alertProductData = true
            this.msgAlertProducts = 'La cantidad no puede ser menor de 1.'
            this.product.cantidad = 1
            this.calculateSubtotal()
            return
          } else {
            this.calculateSubtotal()
          }
          let cont = 0
          let ban = true
          if (!this.editProduct) {
            while (cont < this.factura.lstProductos.length && ban) {
              if (this.factura.lstProductos[cont].producto.codArticle.toString() === this.product.producto.codArticle.toString()) {
                ban = false
              }
              cont++
            }
            if (ban) {
              this.product.producto.description = this.product.producto.description.replace(/(\r\n|\n|\r)/gm, ' ')
              if (this.product.producto.description.length > 300) {
                this.product.producto.description = this.product.producto.description.substring(0, 299)
              }
              this.factura.lstProductos.push(this.product)
            } else {
              if (!ban) {
                this.snackbar = {
                  show: true,
                  color: 'red',
                  text: 'Producto ya agregado dentro de la factura puede modificar su cantidad.',
                }
                this.dialogAddCombo = false
                return
              }
            }
          }
          this.dialogAddCombo = false
          this.viewTable = true
          this.calculateVals()
          this.product = {
            producto: null,
            cantidad: '',
            descripcion: '',
            valorUnitario: '',
            total: '',
            porcentajecero: '',
            retencionir: '',
            retencioniva: '',
            retencionirval: '0',
            retencionivaval: '0',
            cuentagasto: null,
            descuento: '',
          }
          this.dctoProduct = ''
          this.banDescuento = true
        } else {
          this.viewTable = true
          if (parseFloat(this.product.cantidad) <= 0) {
            this.alertProductData = true
            this.msgAlertProducts = 'La cantidad no puede ser menor de 1.'
            this.product.cantidad = 1
            this.calculateSubtotalKeyUp()
            return
          } else {
            this.calculateSubtotalKeyUp()
          }
          let cont = 0
          let ban = true
          if (!this.editProduct) {
            while (cont < this.factura.lstProductos.length && ban) {
              if (this.factura.lstProductos[cont].producto.codArticle.toString() === this.product.producto.codArticle.toString()) {
                ban = false
              }
              cont++
            }
            if (ban) {
              this.product.producto.description = this.product.producto.description.replace(/(\r\n|\n|\r)/gm, ' ')
              if (this.product.producto.description.length > 300) {
                this.product.producto.description = this.product.producto.description.substring(0, 299)
              }
              this.factura.lstProductos.push(this.product)
            } else {
              if (!ban) {
                this.snackbar = {
                  show: true,
                  color: 'red',
                  text: 'Producto ya agregado dentro de la factura puede modificar su cantidad.',
                }
                this.dialogAddProduct = false
                return
              }
            }
          }
          this.dialogAddProduct = false
          this.viewTable = true
          this.calculateVals()
          this.product = {
            producto: null,
            cantidad: '',
            descripcion: '',
            valorUnitario: '',
            total: '',
            porcentajecero: '',
            retencionir: '',
            retencioniva: '',
            retencionirval: '0',
            retencionivaval: '0',
            cuentagasto: null,
            descuento: '',
          }
          this.dctoProduct = ''
          this.banDescuento = true
        }
      },
      cancelPriceDialog () {
        this.dialogWholesaler = false
        this.dialogAddProduct = false
      },
      clickCheckMin () {
        if (this.checkMin) {
          this.checkMay = false
        } else {
          this.checkMay = true
        }
      },
      clickCheckMay () {
        if (this.checkMay) {
          this.checkMin = false
        } else {
          this.checkMin = true
        }
      },
      async guardarNota () {
        this.note = this.factura
        if (this.$refs.formAddFactura.validate()) {
          if (this.note.lstProductos.length === 0) {
            this.snackbar = {
              show: true,
              color: 'red',
              text: 'Para continuar debe agregar los productos.',
            }
            return
          }
          if (!this.note.id) {
            this.loadingSave = true
            this.note.estado = true
            this.note.numsecuencial = this.profileLoaded.estab + '-' + this.profileLoaded.ptoEmi + '-' + this.profileLoaded.secuenciales.notaventa.padStart(9, '0')
            this.printNote()
            await this.$store.dispatch('factura/setNoteSale', [this.note, this.profileLoaded.secuenciales.notaventa]).then(res => {
              this.loadingSave = false
              this.snackbar = {
                show: true,
                color: 'green',
                text: 'Nota de Venta agregada de manera correcta.',
              }
              this.$emit('closeModalSale')
            }, reject => {
              this.loadingSave = false
              this.snackbar = {
                show: true,
                color: 'red',
                text: 'Error al momento de guardar la nota de venta.',
              }
            })
          }
        }
      },
      printNote () {
        this.loadingPrintFac = true
        this.note.saldo = this.note.total
        // let imgBs64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAABjCAYAAADeg0+zAAAACXBIWXMAABYlAAAWJQFJUiTwAAAQbUlEQVR42u1dh3tUVRbnf9hvv5WuJBAkhZKEJEAoZkICBKWpVAUERClSFQgl9CZIjYAiuAvLoq4FdEURRQQVFUGa9A5SpUsJ4ez9nXn35c3kvZk3aQQ49/t+32TevHLL+d1T7rkvZWrEPkECgcAeZaQTBAIhiEAgBBEIhCACgRBEIBCCCARCEIFACCIQCEEEAiGIQCAQgggEQhCBQAgiEAhBBAIhiEAgBBEIhCACgRBEIBCCCARCEOkIgUAIIhAIQQQCIYhAIAQRCIQgAoEQRCAQgggEQhCBQAgiEAiEIAKBEEQgEIIIBEIQgUAIIhAIQQQPOh6v08TVMSFIATuzuO7t9Cy35xXmOQVtZyjXBTq3IL/heEGeHxmXQlHxHh/g2P1IlDL3khi6s6rXbkzVajaiiFqNqJofIiyfOF93Pj7dDnoEX9/YdtDz6tCE6xCqYOrz8Il6oi3+z7F+Rvi1y7+t+notWG7r4v8M/34LRlzb61z2hXVc8D0sqgFVikigitXqMvA3jul2RcbdP0QpFRqkTr1mlNj4SYpLbmGLeAWcg/MfrZFEFVSnV41pyJ0daJbTv9Vt1JJiGzQPeF7NhKZch2ACFUhAcH2tpDRTyO0EEe1JUPWxayfqGF03lcKiG1DFCK9wgdhuiaJ/r9swgxJUXYD45AzXGqRuw5aW61pQjTrurkP9MB4YFxxLb9WFuvceQv0Gj2J06z2Y0p7qzP2Cc6rVbBgS+R9agkTFp1Dlx5NowdvL6Pr1v+jSpct09dp1W1y5cpX+vHiJtmzbQVNmzKekJ1qpaxNNTRJodjxw6Ait/O9qelQ9S6v6vDp4eIZ7eWAm3bx1i+YtWKqEM8EcwGDA/cKVQKe0aE8X/rxIo8ZNp/LhcUrQPbb1+eKrb+nK1Wt0WbUnXxuN44ePHKePV39B/YaMZsJVNAQvmNaEAMYoom/ZuoPOnbvA9dn04y9Br8OkAHL+tmM3nTWu+/rbTXy/YGYp7g0y1/e0plnzF9Ou3/fxWPqXa9ev087de+n12Qupnho79PH9YHbdY4J4uHPf//BT7sSFi5fRvIVLKfutf1L2ojzMX/Quvb10BX20ag3t2XvA7PA+g0ayRnESAJhN+Lx58xZ99c1GqlQ9kUlpPSda1QGz2tDMieZgDnxtLAslZvNgg4dnw3zADIkyZUY2la0Sa3stBBFCAgGak/2OTzvRRrR/5Qer6LtNm+nS5St8v/MX/qSxk95g869qTLKpNZ0IUjOxKZ08ddpsy6HDR10RBBoMpNIF9YxwIIiVrI9F1qNR419X9bxoXnv37l26c+cO5ebmMnJy7vAxXc6eO0/DRk/mseN7lWKS3HuCKEHE7H7jxk2qElWf/vFYbZ6By4XFWpD3PVwJSbtOL9KRoye4s7u/NIQ1iZ3gVDe+Y1b+/MtvqDIIEudMEAwmhAufLZ/uxgMYSCCtBGn6ZCeuz8Tpc6lsmJcg/ufCtIDgbdu+m/5WMYbKoZ3Wtqq/H6lSh+sJzdGzz6u09bddfN/vlSaACQfzy6lOTBClQaCBdMGE4pYgJ07+YV639bedthrEx+dS7fmPIrQu0MDWcvv2bbqdk+NzzHrO0mXvs/YtzZGuUkGQ9z5czZ2JQcLxGCVcMFHyI5UHu3zVeGqQ2oZuqc7mma6W/UynCXJVmS5r1q53Joi636sjvRqkhxLKo8dP0h+nz1Jt5fdACAIJmD9BJgUhyC5V39179rMjHM3tTM3XRtQRwlmpegJVUTM0tBLK/oOHmSTQJHZ10gTRkwfK3v0HXRPk1B9nzOu2bd/laGLhftAcy1d+zOdCQ+QYRDhz9hy9teTfygcZTM3bPE8Z7bpSH2W+gkjXlBnpJU4OaxgUnFvZRrMLQXwI8indUgSBQGKwgl0HIQBJVrz3CXdyk2bP8Mzq71+EQpAhIybwvVq260bNWnfhv9et38iCEGiGKwhBYKfrqE6ge0cb0TpolaGZ3vpt2LiZ7+NoYhUjQfC31yxOoGGjJvN5EHQt7J989iUTGGMDrY426ogWtDT66MeftxqkymFNjdJXmcqYDIJpayGIS4KwY62Efdobb3IHI2oC86wwBNEC2Kl7P2X+RNPwMVP4+5w33+Hfox0Gr6gIEsgRxr0gdAsXL+dnDB8zlfvNP5BQnATRnzgX0S5oWK0NUGAmo38RzWItaJBbh39xDJMN7oPAAQrGHOWg8pPgO9lF/4QgIRIEHQwTDDOStn/rp7Q2zY4CaxCDIM8+9zILL86FjYzSu/9wR6e9OAlidYjRL7WS0unc+Qt0+OhxW61jT5BDXmE16uoPmDYIZiA0HEyDaH9twtQ5XgG/5RXwPfu8fg7Od9ICOMYhbDWRJTdty5EyrUlQBg0bZ0YPS5MWKTUEgQ8SW7+52cn2g+nhMCZmolqJaezYf/f9T/zdnxyFIYi+HwT6l1+383EQAMf9B7C4CWIVLmiRuQuW8HM6v9DfsN09Pguu/gSBk45ZHSZoeHQyO8VWYGJBu9Cv1uiXkw+C87WZdNvQADBPK7iI+unJrXy4asebS3xItnbdhlLpi5QeDaIcbl4IfDyJBxMmkz/QgRCSuAbNTcGFz1Alsr6901pAgqAOMQmpLFCI2WN94vCRYzy4mMmtzyoJgui+Qr06duvHz5k59y3ui2iLmWVHkEOq3ghBp2Z0oKYtO1KqH1DvlObtqVX7HrwG4kSQSKP+0NY6BI0CTYCASVUOZgRPY0F/YSwRJYTvosO/R5RWxGJwaTOzSsU6COxXOGytO/TkwUT0o3nr53yAaMjzvQbSjDmLOBx56PAxFmZ0NmadwkaxfAhirK0gqoRr2j/fh3/73xdf+yw2avOnJAgC4YMmgICifLR6jblQ6kSQ3Ny73K9oPxZar1y96v20wjiGCBOEVTvO+QiCyFWNehxiR9QK90bZsWsPTySRLlbbrfVEGPvY8ZMm0VBHEBj9YmcNPLQEQfRi+cqPzAUmtwVqXef4RDmspheGIJp0EHT8PnrCDP4dgQF22ut6SpQg2kGuXS+dFz7Xf/cDh4ADEyQ3pD4NRBCtwWDa6egVCkxcrcED5Xmh7zXRtBmNftDPhanVom1Xx3s9xBokwXS2sya9QZljp/HKrD/GTJhJ46fO5tXmzYYNfPTYCerYtS8PXFRRmlgGQawpMSAjNJ1enES99bpMSREEq+lICYFji5QVzOjBCBJq0YKfnyAp3C8dVH9biQRT106orVEv1Ak5WWi/zm7A2P++d7/5XGQXpCvrISxKCGLrg2CFFaoaMf8K1eLZvvaBseqM87Ga3urZHqqDvWknL7w81EsSPwe6KAiitYQWFixMwsRo0uxZNu9iODJTEiaWl4jNlLnJC2xLV+QL9dr5IKfPnKWRatIZMWYqZWZNpRF+yMyaxmkf46fM9vEt7Ews7/O70I2bN83zjp84lc93sI4B+nbJv97jc99d/oERKEimpCZPmZEsFAQIkCRZzUWY/6FfSY8OsJKuI1yVjJAg/JHTZ86xU+3v4BWVBtELZBCQRmlPc/QM0SH9Gwhb3ARB+xEpGjJivJkvVsEFQbBqj/MwweSbdBTQdkxK0E7WVBO7KJZOhoTmZm1jaBGOqPlNUJpQs7MXm6vtKJ9+vo61b7cXB/mEebE24hSNFIKEuFDIq+mJaaxRxk6eZQzSK6YWKWqCWEOtIGaXHgO8jvKqNXwuQp9pJRTFWr/hB85vQjYznHbr3gqndRAItV6s8590Yox6YvYOtg6ifUZtauq8KgQvKrHJ6cnX3hXvf2Kae3pREWOx7puNPmHeidPmmhpR1kGKgCA6Tb33K8N9YvHFRRArSXD+xGnexbLJr8+jv1euyZG24loohHbErAv7HwVBjXuxku4fatbZuiiDh4+nRx6rY2j5PPMU5yPyqEuOJXlR+zuXlWnXwNPGILxokEITRAsNBBVOPQpCwJWLUYP474HAvVZ9tpaveabLS1TPCL8WNUHQTjjj8Q0zOL0Daf5eYbLJHCiBZEUd7kV/WjUAxg+OOMw2nVKiF3jRvy8NGGH6HNZUeJRxygpAyDpacrHcrqSn2K6k69QImAWwmRE9Qer4Xzdu8K5BHIssBh/EPvXDG6o8cPAIXbx4mTp172/sB5kfPJtXEQR+S5RjGz2muQKBA/l0SLRn39eMfS2eEs/m1W0HORs2bUdnzp73IQnKBx9/Rm069jI2kiWbuVnprTqb0UdNEB2CfmXoGN5DE+pOzoduJR3fMTthAPxTIgCssENlw/dAJ2r7FmsTlWx2ARYHQazmBgia0qIDO+06TWOSMrnKBSKIEnREwmAyhcck50v/QJgTbUEbIaD9h4w208QhSIGyXgtPkOCpJlZTC4uGWGjUJNEaIVcJ/r4Dh+n7zVvox59+5TR9q4mliaFNLBTkd8l+EId1EAg6Fr/SnuzMMxPS1xun54cnowNHTJBmoWc7JBRa07/twrwXL11mR9KOIFFGAh5saG0uMUGC2MLaH0H9e/UbZg40dv+V4y23+fOSoOGwrRXJfUhh8W8nviMzuZfSEtmL3uX0C50M2FbNylpzOM2ymiAHDx31iWK5IkiDFnTs+CnzOmzbrR5gRyHqAZMWqT579h302SRlFXyrv2Fdl8GuQms2MEpG266ykm5HEKRNhFp+3baTBVPbu/bZrd7vesXXq2VS8oVPEQIdkeX1ZeCAeqNhKa58IR1+nToz29RmCJvaaRAInN4y7GZV+6ct2zicy1tba9QL+qID75bbNN67rwsmEjcEgY+jNRWnoCuSRQTZk84aX/U/SIm95tYwsVPZvvN36jNwJJvTa7/eYB7HXn4J89oANiq0AsJ8WRNn8gzsBCxswQZvnP60mbwYaOO/Tj/BdVhMxLPsX7qQzDP3uCmzONfJaUNSoFQKCCcCBq3b93BcDcZ52F2HjICsSfZtxUak53oO4DAuSIFcNS2Mbt5qAmJDG+JecH4HvJoV1K7HRIJQMLYd6+v6Kofb3fM85ttK6tRvxlHFBYuX8Ur/5l+20aYffuZw+PRZCzinDWTEBMRmtAJ+w558TFKRpXDrbal4LxZMmrLGvuyyAQDTBVoAAm1NgAv2vid0vs4FsnsvFgYG9j+eod+NFep7sQDUT2/csnsvFoD6B2qjrqsOeYb6yh98IhNB96V+I4qbfoIvZl6n6hnKS+dQTwQuKhrvw0I/hBu+5KOK6Ag2gBh578byZidgLJ1MZNEgehbizNlUF/B9S5/7HXmegDOwjs5os6igb1bUuVmBtFnegl2wNob+dkWzHpZnuCGY03WhvlnR+sI7PUZ6o1Y0H0+xCZmX7teT3pevHi3o6ziL69WjBX2O870UYovuVaWhvJmxOMcmUD/La38EAnl5tUAgBBEIhCACgUAIIhAIQQQCIYhAIAQRCIQgAoEQRCAQgggEQhCBQAgiEAhBBAKBEEQgEIIIBEIQgUAIIhAIQQQCIYhAIAQRCIQgAoEQRCAQgkgnCARCEIFACCIQCEEEAiGIQCAEEQiEIAKBEEQgEIIIBA8hQfR/ERKEhkjzv2J5BA8wykQ6/DN7gT1q8P8NTOV/sFkuPJb/r1/5qnGCBxRlwqISSeAe4dFJVD6sJrXv2oeGj51Og0ZMpMGZkwQPKP4PnD+QxYAUEqIAAAAASUVORK5CYII='
        if (this.$store.state.profile.profileLoaded.print) {
          functions.printDataNote(this.note, this.$store.state.profile.profileLoaded, 'print-note')
        }
        this.loadingPrintFac = false
        // if (this.$store.state.profile.profileLoaded.urlImg) {
        //   if (this.$store.state.profile.profileLoaded.urlImg !== '') {
        //     this.$store.dispatch('facturacion/getComanyImg', this.$store.state.profile.profileLoaded.urlImg)
        //       .then(dataUrl => {
        //         imgBs64 = dataUrl
        //         printerFunctions.printSaleBilling(this.note, this.$store.state.profile.profileLoaded, imgBs64, 'Nota de Venta').then(res => {
        //           this.loadingPrintFac = false
        //         })
        //       })
        //   } else {
        //     printerFunctions.printSaleBilling(this.note, this.$store.state.profile.profileLoaded, imgBs64, 'Nota de Venta').then(res => {
        //       this.loadingPrintFac = false
        //     })
        //   }
        // } else {
        //   printerFunctions.printSaleBilling(this.note, this.$store.state.profile.profileLoaded, imgBs64, 'Nota de Venta').then(res => {
        //     this.loadingPrintFac = false
        //   })
        // }
      },
      filterComboTxt () {
        this.comboLstFilter = this.comboLst.filter(item => {
          return item.codArticle.toUpperCase().includes(this.searchCombo.toUpperCase()) || item.name.toUpperCase().includes(this.searchCombo.toUpperCase()) || item.description.toUpperCase().includes(this.searchCombo.toUpperCase())
        })
      },
      addnewCombo (combo) {
        this.dialogAddCombo = true
        this.productToEdit = combo
        this.product = {
          producto: this.productToEdit,
          cantidad: '1',
          descripcion: '',
          valorUnitario: this.productToEdit.activeValue,
          total: this.productToEdit.activeValue,
          porcentajecero: '',
          descuento: '',
          ice: '',
          irbpnr: '',
        }
        this.getProductValue(this.product, this.product.producto.activeValue, this.product.producto.tarifaiva.texto)
      },
      addNewProduct () {
        this.forEditProduct = false
        this.dialodInvMod = true
        this.productToEdit = {
          codArticle: '',
          barcode: '',
          name: '',
          description: '',
          type: {
            codigo: '01',
            texto: 'BIEN',
          },
          quantity: '',
          activeValue: '',
          activeWValue: '',
          productKey: '',
          completeData: '',
          tarifaiva: {
            codigo: '0',
            texto: '0%',
            valor: '0',
          },
          irbpnr: '',
          tarifaice: '',
          totalValue: '',
        }
      },
      async closeInventoryModal () {
        this.dialodInvMod = false
      },
      async closeInventoryModalCombo () {
        this.dialodInvModCombo = false
      },
      toCertifElect () {
        this.$router.replace('/pages/certification')
      },
      addNewProductCombo () {
        this.forEditProductCombo = false
        this.dialodInvModCombo = true
        this.productToEditCombo = {
          codArticle: '',
          barcode: '',
          name: '',
          description: '',
          type: {
            codigo: '02',
            texto: 'SERVICIO',
          },
          quantity: '1',
          activeValue: '',
          activeWValue: '',
          productKey: '',
          completeData: '',
          tarifaiva: {
            codigo: '2',
            texto: '12%',
            valor: '12',
          },
          irbpnr: '',
          tarifaice: '',
          totalValue: '',
          inecCode: null,
          combo: true,
        }
      },
      addNewClient () {
        this.dialogCLient = true
        this.clientToEdit = {
          idType: {
            codigo: '05',
            texto: 'CEDULA',
          },
          businessName: '',
          name: '',
          lastName: '',
          mail: '',
          address: '',
          ide: '',
          phone: '',
          cellphone: '',
          clientKey: '',
        }
      },
      changeSendSri () {
        this.alertData = true
      },
      isNumber (evt) {
        evt = (evt) || window.event
        var charCode = (evt.which) ? evt.which : evt.keyCode
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault()
        } else {
          return true
        }
      },
      printFacturaPrev () {
        let myWindow = null
        if (this.$store.state.profile.profileLoaded.print) {
          myWindow = window.open('', 'print-sale', 'fullscreen="yes"')
        }
        this.printFactura(myWindow)
      },
      printFactura (myWindow) {
        this.loadingPrintFac = true
        let banContinuePrint = false
        if (this.factura.claveAcceso) {
          banContinuePrint = true
        } else {
          if (this.profileLoaded.genAutomaticInvoice) {
            this.factura.claveAcceso = 'No-Emitido-' + this.factura.numsecuencial
            banContinuePrint = true
          }
        }
        if (banContinuePrint) {
          // const dataSend = {
          //   accesKey: this.factura.claveAcceso,
          //   token: this.$store.state.facturacion.tokenUser,
          //   aditionalField: this.$store.state.profile.profileLoaded.aditionalField ? this.$store.state.profile.profileLoaded.aditionalField : false,
          // }
          if (this.$store.state.profile.profileLoaded.print) {
            functions.printData(this.factura, this.$store.state.profile.profileLoaded, myWindow)
          }
          this.loadingPrintFac = false
          // this.$store.dispatch('facturacion/getPdfFacValid', dataSend).then(res => {
          //   this.loadingPrintFac = false
          // })
          // return
        }
        // let imgBs64 = 'data:image/png;base64,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'
        // if (this.$store.state.profile.profileLoaded.urlImg) {
        //   if (this.$store.state.profile.profileLoaded.urlImg !== '') {
        //     this.$store.dispatch('facturacion/getComanyImg', this.$store.state.profile.profileLoaded.urlImg)
        //       .then(dataUrl => {
        //         imgBs64 = dataUrl
        //         printerFunctions.printSaleBilling(this.factura, this.$store.state.profile.profileLoaded, imgBs64, 'Factura').then(res => {
        //           this.loadingPrintFac = false
        //         })
        //       })
        //   } else {
        //     printerFunctions.printSaleBilling(this.factura, this.$store.state.profile.profileLoaded, imgBs64, 'Factura').then(res => {
        //       this.loadingPrintFac = false
        //     })
        //   }
        // } else {
        //   printerFunctions.printSaleBilling(this.factura, this.$store.state.profile.profileLoaded, imgBs64, 'Factura').then(res => {
        //     this.loadingPrintFac = false
        //   })
        // }
      },
      closeModalClient () {
        this.dialogCLient = false
      },
      closeModalProvider () {
        this.dialodProveedor = false
      },
      calculateTurned () {
        this.alertProductTurned = false
        this.valTurned = accounting.toFixed(parseFloat(this.valPayment) - parseFloat(this.factura.total), 3)
      },
      makePayment () {
        // if (!this.valPayment) {
        //   this.msgAlertTurned = 'Ingrese el valor cancelado por el cliente.'
        //   this.alertProductTurned = true
        //   return
        // }
        // if (this.valPayment.toString() === '') {
        //   this.msgAlertTurned = 'Ingrese el valor cancelado por el cliente.'
        //   this.alertProductTurned = true
        //   return
        // }
        if (this.valPayment) {
          if (this.valPayment.toString() !== '') {
            if (parseFloat(this.valPayment) < parseFloat(this.factura.total)) {
              this.alertProductTurned = true
              this.msgAlertTurned = 'El valor cancelado no puede ser menor al valor a pagar.'
              return
            }
          }
        }
        this.dialogSaveFac = false
        if (this.notaVenta) {
          this.guardarNota()
        } else {
          this.guardarFactura()
        }
      },
      previewSaveFac () {
        this.alertProductTurned = false
        if (this.$refs.formAddFactura.validate()) {
          if (this.factura.lstProductos.length === 0) {
            this.snackbar = {
              show: true,
              color: 'red',
              text: 'Para continuar debe agregar los productos.',
            }
            return
          }
          if (parseFloat(this.factura.total) >= 200 && this.factura.client.ide.toString() === '9999999999999') {
            this.snackbar = {
              show: true,
              color: 'red',
              text: 'Recuerde que a partir de $200 no se puede emitir una factura como CONSUMIDOR FINAL.',
            }
            return
          }
          if (this.factura.formapago.codigo.toString() === '01' && !this.factura.pendientepago) {
            this.dialogSaveFac = true
            this.valPayment = ''
            this.valTurned = ''
          } else {
            if (this.notaVenta) {
              this.guardarNota()
            } else {
              this.guardarFactura()
            }
          }
        }
      },
      async guardarFactura () {
        if (this.$refs.formAddFactura.validate()) {
          if (this.factura.lstProductos.length === 0) {
            this.snackbar = {
              show: true,
              color: 'red',
              text: 'Para continuar debe agregar los productos.',
            }
            return
          }
          if (parseFloat(this.factura.total) >= 200 && this.factura.client.ide.toString() === '9999999999999') {
            this.snackbar = {
              show: true,
              color: 'red',
              text: 'Recuerde que a partir de $200 no se puede emitir una factura como CONSUMIDOR FINAL.',
            }
            return
          }
          if (!this.factura.id) {
            this.loadingSave = true
            this.factura.estado = true
            this.factura.numsecuencial = this.profileLoaded.estab + '-' + this.profileLoaded.ptoEmi + '-' + this.profileLoaded.secuenciales.facventa.padStart(9, '0')
            if (this.companyDataLoad) {
              if (this.companyDataLoad.sendSri) {
                if (this.sendSri) {
                  let userSend = this.$store.state.users.user.email
                  if (userSend.length > 20) {
                    userSend = userSend.substr(0, 19)
                  }
                  await this.$store.dispatch('facturacion/userLoginFacInTo', [userSend, this.profileLoaded.valuidfac])
                  this.factura.companyData = this.companyDataLoad
                  this.factura.token = this.$store.state.facturacion.tokenUser
                  this.factura.sendSri = true
                }
              }
            }
            this.factura.userProfile = this.profileLoaded
            let myWindow = null
            if (this.$store.state.profile.profileLoaded.print) {
              myWindow = window.open('', 'print-sale', 'fullscreen="yes"')
            }
            this.$store.dispatch('factura/setFacturaSale', [this.factura, this.profileLoaded.secuenciales.facventa]).then(res => {
              this.loadingSave = false
              if (res) {
                this.loadingSave = false
                if (res.data) {
                  if (res.data.statusError) {
                    if (!this.profileLoaded.genAutomaticInvoice) {
                      this.dialogError = true
                      this.msgFacError = res.data.messageError
                      return
                    }
                  } else {
                    if (res.data.claveAcceso) {
                      this.factura.claveAcceso = res.data.claveAcceso
                    }
                  }
                }
                this.snackbar = {
                  show: true,
                  color: 'green',
                  text: 'Factura agregada de manera correcta.',
                }
                this.printFactura(myWindow)
                const data = {
                  msg: 'SUCCESS',
                  obj: this.factura,
                }
                this.$emit('closeModalSale', data)
              } else {
                this.loadingSave = false
                this.snackbar = {
                  show: true,
                  color: 'red',
                  text: 'Error al momento de enviar la factura.',
                }
              }
            }, reject => {
              this.loadingSave = false
              this.snackbar = {
                show: true,
                color: 'orange',
                text: 'Factura generada con inconvenientes.',
              }
              setTimeout(() => {
                const data = {
                  msg: 'ERROR',
                  obj: this.factura,
                }
                this.$emit('closeModalSale', data)
              }, 3000)
            })
          }
        }
      },
      async sendEmailFac () {
        let userSend = this.$store.state.users.user.email
        if (userSend.length > 20) {
          userSend = userSend.substr(0, 19)
        }
        await this.$store.dispatch('facturacion/userLoginFacInTo', [userSend, this.profileLoaded.valuidfac])
        this.factura.token = this.$store.state.facturacion.tokenUser
        this.loadingSendMail = true
        const aditionalField = this.$store.state.profile.profileLoaded.aditionalField ? this.$store.state.profile.profileLoaded.aditionalField : false
        this.$store.dispatch('factura/sendFacUserMail', [this.factura, aditionalField]).then(res => {
          this.loadingSendMail = false
          if (res) {
            this.snackbar = {
              show: true,
              color: 'green',
              text: 'Correo enviado de manera correcta.',
            }
          } else {
            this.snackbar = {
              show: true,
              color: 'red',
              text: 'Error al momento de enviar el correo con la factura.',
            }
          }
        }, reject => {
          this.loadingSendMail = false
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Error al momento de enviar el correo con la factura.',
          }
        })
      },
      acceptConfirmationDelete () {
        this.deleteItem(this.deleteItemSend)
        this.confirmationDialogProduct = false
      },
      openDeleteItem (item) {
        this.deleteItemSend = item
        this.confirmationDialogProduct = true
      },
      deleteItem (item) {
        let cont = 0
        let ban = true
        while (cont < this.factura.lstProductos.length && ban) {
          if (this.factura.lstProductos[cont].producto.codArticle.toString() === item.producto.codArticle.toString()) {
            this.factura.lstProductos.splice(cont, 1)
            ban = false
          }
          cont++
        }
        this.calculateSubtotal()
        this.calculateVals()
      },
      addProduct () {
        this.viewTable = true
        if (this.$refs.formAddProduct.validate()) {
          if (parseFloat(this.product.cantidad) <= 0) {
            this.alertProductData = true
            this.msgAlertProducts = 'La cantidad no puede ser menor de 1.'
            this.product.cantidad = 1
            this.calculateSubtotal()
            return
          }
          let cont = 0
          let ban = true
          if (!this.editProduct) {
            while (cont < this.factura.lstProductos.length && ban) {
              if (this.factura.lstProductos[cont].producto.codArticle.toString() === this.product.producto.codArticle.toString()) {
                ban = false
              }
              cont++
            }
            if (ban) {
              this.product.producto.description = this.product.producto.description.replace(/(\r\n|\n|\r)/gm, ' ')
              if (this.product.producto.description.length > 300) {
                this.product.producto.description = this.product.producto.description.substring(0, 299)
              }
              this.factura.lstProductos.push(this.product)
            } else {
              if (!ban) {
                this.snackbar = {
                  show: true,
                  color: 'red',
                  text: 'Producto ya agregado dentro de la factura puede modificar su cantidad.',
                }
                this.dialogAddProduct = false
                return
              }
            }
          }
          this.dialogAddProduct = false
          this.viewTable = true
          this.calculateVals()
          this.product = {
            producto: null,
            cantidad: '',
            descripcion: '',
            valorUnitario: '',
            total: '',
            porcentajecero: '',
            retencionir: '',
            retencioniva: '',
            retencionirval: '0',
            retencionivaval: '0',
            cuentagasto: null,
            descuento: '',
          }
          this.dctoProduct = ''
          this.banDescuento = true
        }
      },
      addProductCombo () {
        this.viewTable = true
        if (this.$refs.formAddProductCombo.validate()) {
          if (parseFloat(this.product.cantidad) <= 0) {
            this.alertProductData = true
            this.msgAlertProducts = 'La cantidad no puede ser menor de 1.'
            this.product.cantidad = 1
            this.calculateSubtotal()
            return
          }
          let cont = 0
          let ban = true
          if (!this.editProduct) {
            while (cont < this.factura.lstProductos.length && ban) {
              if (this.factura.lstProductos[cont].producto.codArticle.toString() === this.product.producto.codArticle.toString()) {
                ban = false
              }
              cont++
            }
            if (ban) {
              this.product.producto.description = this.product.producto.description.replace(/(\r\n|\n|\r)/gm, ' ')
              if (this.product.producto.description.length > 300) {
                this.product.producto.description = this.product.producto.description.substring(0, 299)
              }
              this.factura.lstProductos.push(this.product)
            } else {
              if (!ban) {
                this.snackbar = {
                  show: true,
                  color: 'red',
                  text: 'Producto ya agregado dentro de la factura puede modificar su cantidad.',
                }
                this.dialogAddCombo = false
                return
              }
            }
          }
          this.dialogAddCombo = false
          this.viewTable = true
          this.calculateVals()
          this.product = {
            producto: null,
            cantidad: '',
            descripcion: '',
            valorUnitario: '',
            total: '',
            porcentajecero: '',
            retencionir: '',
            retencioniva: '',
            retencionirval: '0',
            retencionivaval: '0',
            cuentagasto: null,
            descuento: '',
          }
          this.dctoProduct = ''
          this.banDescuento = true
        }
      },
      calculateVals () {
        let sub = 0
        let iva = 0
        let dcto = 0
        let subcero = 0
        let noobjiva = 0
        let exentoiva = 0
        let valDcto = 0
        for (let i = 0; i < this.factura.lstProductos.length; i++) {
          const valTot = parseFloat(this.factura.lstProductos[i].cantidad * this.factura.lstProductos[i].valorUnitario)
          if (this.factura.lstProductos[i].descuento && this.factura.lstProductos[i].descuento.toString() !== '') {
            valDcto = parseFloat(this.factura.lstProductos[i].descuento)
            sub = sub + parseFloat(valTot) - parseFloat(valDcto)
            iva = iva + ((parseFloat(valTot) - parseFloat(valDcto)) * ((parseFloat(this.factura.lstProductos[i].producto.tarifaiva.valor)) / 100))
            dcto = dcto + valDcto
            if (this.factura.lstProductos[i].producto.tarifaiva.codigo.toString() === '0') {
              subcero = subcero + parseFloat(valTot) - parseFloat(valDcto)
            }
            if (this.factura.lstProductos[i].producto.tarifaiva.codigo.toString() === '6') {
              noobjiva = noobjiva + parseFloat(valTot) - parseFloat(valDcto)
            }
            if (this.factura.lstProductos[i].producto.tarifaiva.codigo.toString() === '7') {
              exentoiva = exentoiva + parseFloat(valTot) - parseFloat(valDcto)
            }
          } else {
            sub = sub + parseFloat(valTot)
            iva = iva + ((parseFloat(valTot)) * ((parseFloat(this.factura.lstProductos[i].producto.tarifaiva.valor)) / 100))
            if (this.factura.lstProductos[i].producto.tarifaiva.codigo.toString() === '0') {
              subcero = subcero + parseFloat(valTot)
            }
            if (this.factura.lstProductos[i].producto.tarifaiva.codigo.toString() === '6') {
              noobjiva = noobjiva + parseFloat(valTot)
            }
            if (this.factura.lstProductos[i].producto.tarifaiva.codigo.toString() === '7') {
              exentoiva = exentoiva + parseFloat(valTot)
            }
          }
        }
        const tot = parseFloat(accounting.toFixed(sub, 2)) + parseFloat(accounting.toFixed(iva, 2))
        const saldo = parseFloat(tot)
        this.factura.subtotal = accounting.toFixed(sub, 2)
        this.factura.subcero = accounting.toFixed(subcero, 2)
        this.factura.noobjiva = accounting.toFixed(noobjiva, 2)
        this.factura.excentoiva = accounting.toFixed(exentoiva, 2)
        this.factura.totdcto = accounting.toFixed(dcto, 2)
        this.factura.ice = '0.00'
        this.factura.irbpnr = '0.00'
        this.factura.iva12 = accounting.toFixed(iva, 2)
        this.factura.total = accounting.toFixed(tot, 2)
        this.factura.saldo = accounting.toFixed(saldo, 2)
      },
      getProductValue (product, activeVal, txtIva) {
        product.valorUnitario = parseFloat(activeVal.toString().replace(',', '.'))
        this.valIvaTxt = txtIva
        this.calculateSubtotal()
      },
      setValSelected () {
        if (this.checkMin) {
          this.product.valorUnitario = parseFloat(this.activeValView.toString().replace(',', '.'))
          this.valIvaTxt = this.txtIvaView
          this.calculateSubtotal()
        } else {
          this.product.valorUnitario = parseFloat(this.activeValueWholesalerView.toString().replace(',', '.'))
          this.valIvaTxt = this.txtIvaView
          this.calculateSubtotal()
        }
        this.dialogWholesaler = false
      },
      getProductValueWholesaler (product, activeVal, activeValueWholesaler, txtIva) {
        if (product.producto.activeValueWholesaler) {
          if (product.producto.activeValueWholesaler.toString().trim() !== '') {
            if (parseFloat(product.producto.activeValueWholesaler) > 0) {
              this.activeValView = activeVal
              this.activeValueWholesalerView = activeValueWholesaler
              this.txtIvaView = txtIva
              this.dialogWholesaler = true
              this.checkMin = true
              this.checkMay = false
            } else {
              product.valorUnitario = parseFloat(activeVal.toString().replace(',', '.'))
              this.valIvaTxt = txtIva
              this.calculateSubtotal()
            }
          } else {
            product.valorUnitario = parseFloat(activeVal.toString().replace(',', '.'))
            this.valIvaTxt = txtIva
            this.calculateSubtotal()
          }
        } else {
          product.valorUnitario = parseFloat(activeVal.toString().replace(',', '.'))
          this.valIvaTxt = txtIva
          this.calculateSubtotal()
        }
      },
      editElement (item) {
        this.editProduct = true
        this.dialogAddProduct = true
        this.banDescuento = true
        this.product = item
        this.dctoProduct = this.product.descuento
        this.alertProductData = false
      },
      addNewElement () {
        this.product = {
          producto: null,
          cantidad: '',
          descripcion: '',
          valorUnitario: '',
          total: '',
          porcentajecero: '',
          retencionir: '',
          retencioniva: '',
          retencionirval: '0',
          retencionivaval: '0',
          cuentagasto: null,
          descuento: '',
        }
        this.editProduct = false
        this.dialogAddProduct = true
        this.product.cantidad = 1
        this.banDescuento = true
        this.dctoProduct = ''
        this.alertProductData = false
        this.disableAdd = false
      },
      calculateSubtotalKeyUp () {
        if (this.product.producto) {
          if (this.product.valorUnitario === null || this.product.valorUnitario === '') {
            this.disableAdd = true
            this.msgAlertProducts = 'Debe agregar el precio unitario del producto.'
            this.alertProductData = true
            return
          }
          const valRest = parseFloat(this.product.producto.quantity) - parseFloat(this.product.cantidad)
          if (valRest < 0 && this.product.producto.type.texto === 'BIEN' && !this.profileLoaded.negativeInventory) {
            this.disableAdd = true
            this.msgAlertProducts = 'La cantidad excede el número de productos en stock.'
            this.alertProductData = true
            return
          } else {
            this.disableAdd = false
          }
          this.product.total = accounting.toFixed((parseFloat(this.product.cantidad) * parseFloat(this.product.valorUnitario)), 3)
          if (this.dctoProduct && this.dctoProduct.toString() !== '') {
            if (this.banDescuento) {
              this.product.total = accounting.toFixed((parseFloat(this.product.total) - parseFloat(this.dctoProduct)), 3)
              this.product.descuento = this.dctoProduct
            } else {
              const valDcto = accounting.toFixed(((parseFloat(this.product.total) * parseFloat(this.dctoProduct)) / 100), 3)
              this.product.total = accounting.toFixed((parseFloat(this.product.total) - parseFloat(valDcto)), 3)
              this.product.descuento = valDcto
            }
          }
          if (parseFloat(this.product.total) < 0) {
            this.alertProductData = true
            this.msgAlertProducts = 'El descuento no puede ser mayor que el valor total a pagar por produto.'
            this.product.total = accounting.toFixed((parseFloat(this.product.cantidad) * parseFloat(this.product.valorUnitario)), 3)
            this.banDescuento = true
            this.dctoProduct = ''
            this.product.descuento = this.dctoProduct
          } else {
            this.alertProductData = false
          }
        }
      },
      calculateSubtotal () {
        if (this.product.producto) {
          if (this.product.valorUnitario === null || this.product.valorUnitario === '') {
            this.disableAdd = true
            this.msgAlertProducts = 'Debe agregar el precio unitario del producto.'
            this.alertProductData = true
            return
          }
          const valRest = parseFloat(this.product.producto.quantity) - parseFloat(this.product.cantidad)
          if (valRest < 0 && this.product.producto.type.texto === 'BIEN' && !this.profileLoaded.negativeInventory) {
            this.disableAdd = true
            this.msgAlertProducts = 'La cantidad excede el número de productos en stock.'
            this.alertProductData = true
            return
          } else {
            this.disableAdd = false
          }
          if (this.product.producto.tarifaiva.valor.toString() !== '0') {
            const valMult = 1 + (parseFloat(this.product.producto.tarifaiva.valor) / 100)
            // if (this.product.producto.activeWValue) {
            //   this.product.valorUnitario = (parseFloat(this.product.producto.activeWValue) / valMult).toFixed(3)
            // } else {
            //   this.product.valorUnitario = parseFloat(this.product.producto.activeValue)
            // }
            if (this.$store.state.profile.profileLoaded.productPrice) {
              if (this.checkMay) {
                if (this.product.producto.activeWValueWholesaler) {
                  this.product.valorUnitario = (parseFloat(this.product.producto.activeWValueWholesaler) / valMult).toFixed(3)
                } else {
                  // this.product.valorUnitario = (parseFloat(this.product.producto.activeWValue) / valMult).toFixed(3)
                  if (this.product.producto.activeWValue) {
                    this.product.valorUnitario = (parseFloat(this.product.producto.activeWValue) / valMult).toFixed(3)
                  } else {
                    this.product.valorUnitario = parseFloat(this.product.producto.activeValue)
                  }
                }
              } else {
                // this.product.valorUnitario = (parseFloat(this.product.producto.activeWValue) / valMult).toFixed(3)
                if (this.product.producto.activeWValue) {
                  this.product.valorUnitario = (parseFloat(this.product.producto.activeWValue) / valMult).toFixed(3)
                } else {
                  this.product.valorUnitario = parseFloat(this.product.producto.activeValue)
                }
              }
            } else {
              // this.product.valorUnitario = (parseFloat(this.product.producto.activeWValue) / valMult).toFixed(3)
              if (this.product.producto.activeWValue) {
                this.product.valorUnitario = (parseFloat(this.product.producto.activeWValue) / valMult).toFixed(3)
              } else {
                this.product.valorUnitario = parseFloat(this.product.producto.activeValue)
              }
            }
          }
          this.product.total = accounting.toFixed((parseFloat(this.product.cantidad) * parseFloat(this.product.valorUnitario)), 3)
          if (this.dctoProduct && this.dctoProduct.toString() !== '') {
            if (this.banDescuento) {
              this.product.total = accounting.toFixed((parseFloat(this.product.total) - parseFloat(this.dctoProduct)), 3)
              this.product.descuento = this.dctoProduct
            } else {
              const valDcto = accounting.toFixed(((parseFloat(this.product.total) * parseFloat(this.dctoProduct)) / 100), 3)
              this.product.total = accounting.toFixed((parseFloat(this.product.total) - parseFloat(valDcto)), 3)
              this.product.descuento = valDcto
            }
          }
          if (parseFloat(this.product.total) < 0) {
            this.alertProductData = true
            this.msgAlertProducts = 'El descuento no puede ser mayor que el valor total a pagar por produto.'
            this.product.total = accounting.toFixed((parseFloat(this.product.cantidad) * parseFloat(this.product.valorUnitario)), 3)
            this.banDescuento = true
            this.dctoProduct = ''
            this.product.descuento = this.dctoProduct
          } else {
            this.alertProductData = false
          }
        }
      },
      cleanOperation () {
        this.factura = {
          client: null,
          nombre: '',
          cedula: '',
          // cadAutorizacion: moment(new Date()).format('YYYY-MM-DD'),
          telefono: '',
          email: '',
          direccion: '',
          lstProductos: [],
          subtotal: '0.00',
          subcero: '0.00',
          noobjiva: '0.00',
          excentoiva: '0.00',
          totdcto: '0.00',
          ice: '0.00',
          irbpnr: '0.00',
          iva12: '0.00',
          total: '0.00',
          fechaEmision: moment(new Date()).format('YYYY-MM-DD'),
          descripcion: '',
          formapago: null,
          proveedor: null,
          saldo: '0.00',
          numeroVoucher: null,
          pendientepago: false,
          fechapago: moment(new Date()).format('YYYY-MM-DD'),
        }
        this.factura.porcentajeiva = vars.validIva
      },
    },
  }
</script>
<style>
  @media screen and (max-width: 500px) {
    .addButton {
      display: none;
    }
  }
  @media screen and (min-width: 500px) {
    .addIcon {
      display: none;
    }
  }
</style>
<style lang="css">
  .v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    height: auto;
    /*color: blue;*/
  }
  view-combo-card {
    height: 270px;
    max-height: 270px !important;
    min-height: 270px !important;
    overflow-y: scroll !important;
  }
</style>
